Ext.define('SA.view.plugin.Animation', {
    alias: 'plugin.sa-animation',
    extend: 'Ext.AbstractPlugin',
    pluginId: 'sa-animation',

    isInitialLayout: true,

    defaultCfg: {
        add: true,
        hide: true,
        initialLayout: false,
        position: true,
        show: true,
        size: true,
        sizeBySides: false,

        duration: 200
    },

    init() {
        this.specs = {};

        this.cmp.on({
            afterlayout: this.onChange,
            move: this.onChange,

            scope: this
        });
    },

    clear() {
        this.resetStyles();
        Ext.EventManager.idleEvent.removeListener(this.onIdleEvent, this);
        this.specs = {};
        this.isInitialLayout = true;
    },

    destroy() {
        Ext.EventManager.idleEvent.removeListener(this.onIdleEvent, this);

        Ext.globalEvents.un('beforelayout', this.resetStyles, this);

        clearTimeout(this.resetTimer);
    },

    getHeight(cmp) {
        var id = cmp.id,
            spec = this.specs[id];

        if (spec && spec.height != null) {
            return spec.height;
        }

        return cmp.getHeight();
    },

    getWidth(cmp) {
        var id = cmp.id,
            spec = this.specs[id];

        if (spec && spec.width != null) {
            return spec.width;
        }

        return cmp.getWidth();
    },

    onChange() {
        Ext.EventManager.idleEvent.addListener(this.onIdleEvent, this);
    },

    onIdleEvent() {
        var ct = this.cmp,
            oldSpecs = this.specs,
            specs = this.specs = {},
            styleResets = this.styleResets = {},
            children = ct.query('[saAnim]'),
            changed = {},
            added = {},
            hidden = {},
            cfgs = {},
            defaultCfg = this.defaultCfg,
            maxDuration = 0,
            isInitialLayout = this.isInitialLayout;

        Ext.EventManager.idleEvent.removeListener(this.onIdleEvent, this);

        if (ct.saAnim) {
            children.push(ct);
        }

        this.isInitialLayout = false;

        children.forEach(cmp => {
            var id = cmp.id,
                cfg = cfgs[id] = {},
                oldSpec = oldSpecs[id],
                el = cmp.el,
                dom = el.dom,
                spec, keys, duration;

            for (let prop in defaultCfg) {
                if (cmp.saAnim[prop] != null) {
                    cfg[prop] = cmp.saAnim[prop];
                }
                else if (this[prop] != null) {
                    cfg[prop] = this[prop];
                }
                else {
                    cfg[prop] = defaultCfg[prop];
                }
            }

            cfg.sizeBySides = cfg.sizeBySides && cfg.size;

            duration = cfg.duration;
            maxDuration = Math.max(maxDuration, duration);

            styleResets[id] = dom.getAttribute('style') || '';

            if (!cmp.isVisible(true)) {
                specs[id] = false;

                return;
            }

            spec = specs[id] = {};

            if (cfg.position || cfg.sizeBySides) {
                spec.left = dom.offsetLeft;
                spec.top = dom.offsetTop;
            }

            if (cfg.size) {
                spec.height = el.getHeight();
                spec.width = el.getWidth();
            }

            if (cfg.add || cfg.show) {
                spec.opacity = el.getStyle('opacity');
            }

            if (cfg.sizeBySides) {
                spec.bottom = dom.offsetParent.offsetHeight - spec.height - spec.top;
                spec.right = dom.offsetParent.offsetWidth - spec.width - spec.left;
            }

            if (!oldSpec) {
                if (oldSpec === false) {
                    if (!cfg.show) {
                        return;
                    }
                }
                else if(!cfg.add || (isInitialLayout && !cfg.initialLayout)) {
                    return;
                }

                added[id] = el;

                return;
            }

            if (cfg.sizeBySides && (oldSpec.height !== spec.height || oldSpec.width !== spec.width)) {
                spec.oldStyles = {
                    bottom: oldSpec.bottom + 'px',
                    left: oldSpec.left + 'px',
                    right: oldSpec.right + 'px',
                    top: oldSpec.top + 'px',

                    height: null,
                    width: null
                };

                spec.newStyles = {
                    bottom: spec.bottom + 'px',
                    left: spec.left + 'px',
                    right: spec.right + 'px',
                    top: spec.top + 'px'
                };

                changed[id] = el;
            }
            else {
                spec.oldStyles = {};
                spec.newStyles = {};

                if (oldSpec.height !== spec.height) {
                    spec.oldStyles.height = oldSpec.height + 'px';
                    spec.newStyles.height = spec.height + 'px';

                    changed[id] = el;
                }

                if (oldSpec.width !== spec.width) {
                    spec.oldStyles.width =  oldSpec.width + 'px';
                    spec.newStyles.width =  spec.width + 'px';

                    changed[id] = el;
                }

                if (cfg.position && (oldSpec.left !== spec.left || oldSpec.top !== spec.top)) {
                    spec.oldStyles.transform = 'translate(' + (oldSpec.left - spec.left)  + 'px, ' + (oldSpec.top - spec.top) + 'px)';
                    spec.newStyles.transform = 'translate(0, 0)';

                    changed[id] = el;
                }
            }

            if (!cfg.sizeBySides) {
                if (cfg.size === 'height') {
                    delete spec.oldStyles.width;
                    delete spec.newStyles.width;
                }

                if (cfg.size === 'width') {
                    delete spec.oldStyles.height;
                    delete spec.newStyles.height;
                }
            }

            keys = Object.keys(spec.newStyles);

            if (keys.length) {
                spec.newStyles.transition = keys.join(' ' + duration + 'ms, ') + ' ' + duration + 'ms';
            }
        });

        for (let id in oldSpecs) {
            if (oldSpecs[id] && !specs[id]) {
                let cmp = Ext.getCmp(id);

                if (cmp && cmp.isHidden()) {
                    let el = hidden[id] = cmp.el;

                    el.setStyle({
                        display: null,
                        opacity: 1,
                        transform: 'scale(1)'
                    });

                    if (oldSpecs[id].left != null) {
                        el.setStyle({
                            left: oldSpecs[id].left + 'px',
                            margin: 0,
                            position: 'absolute',
                            top: oldSpecs[id].top + 'px'
                        });

                        if (oldSpecs[id].height != null) {
                            el.setStyle('height', oldSpecs[id].height + 'px');
                        }

                        if (oldSpecs[id].width != null) {
                            el.setStyle('width', oldSpecs[id].width + 'px');
                        }
                    }
                }
            }
        }

        children.forEach(cmp => {
            var id = cmp.id,
                spec = specs[id],
                el = added[id];

            if (el) {
                el.setStyle('opacity', 0);
                el.setStyle('transform', 'scale(0)');
            }
            else if (el = changed[id]) {
                el.setStyle(spec.oldStyles);
            }
        });

        for (let id in changed) {
            changed[id].getStyle('height');
        }

        for (let id in added) {
            added[id].getStyle('height');
        }

        for (let id in hidden) {
            hidden[id].getStyle('height');
        }

        for (let id in changed) {
            let el = changed[id],
                spec = specs[id];

            el.setStyle(spec.newStyles);
        }

        for (let id in added) {
            let el = added[id],
                spec = specs[id],
                duration = cfgs[id].duration;

            el.setStyle('transition', 'opacity ' + duration + 'ms, transform ' + duration + 'ms');

            el.setStyle('opacity', spec.opacity);
            el.setStyle('transform', null);
        }

        for (let id in hidden) {
            let el = hidden[id],
                duration = cfgs[id].duration;

            el.setStyle('transition', 'opacity ' + duration + 'ms, transform ' + duration + 'ms');

            el.setStyle('opacity', 0);
            el.setStyle('transform', 'scale(0)');
        }

        this.resetTimer = setTimeout(this.resetStyles.bind(this), maxDuration + 150);
        Ext.globalEvents.on('beforelayout', this.resetStyles, this);
    },

    resetStyles() {
        var styleResets = this.styleResets,
            id, cmp, el;

        clearTimeout(this.resetTimer);
        Ext.globalEvents.un('beforelayout', this.resetStyles, this);

        this.styleResets = null;

        for (id in styleResets) {
            cmp = Ext.getCmp(id);

            if (cmp) {
                el = cmp.el;

                if (el) {
                    el.dom.setAttribute('style', styleResets[id]);

                    el[cmp.hidden ? 'hide' : 'show']();
                }
            }
        }
    }
});
